module.exports = __webpack_public_path__ + "static/media/chevron-blue-down.2598ed6a.svg";